import React, { useState } from 'react';
import ArrowLeftCircle from '../../../assets/icons/arrow-left-circle.svg';
import ArrowRightCircle from '../../../assets/icons/arrow-right-circle.svg';

const ProgressBar = ({
  handleSeek,
  handleSeekBack,
  handleSeekForward,
  played,
}) => {
  const [playTime, setPlayTime] = useState('00:00:00');
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const handleMouseMove = (event) => {
    const seekBar = event.currentTarget;
    const seekBarRect = seekBar.getBoundingClientRect();
    const clickX = event.clientX - seekBarRect.left;
    const seekBarWidth = seekBarRect.width;
    const percentage = clickX / seekBarWidth;
    const totalSeconds = Math.floor(percentage * 86400);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const formattedSeekTime = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    setPlayTime(formattedSeekTime);

    setTooltipPosition({
      top: event.clientY + 20,
      left: event.clientX,
    });
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };
  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            width: '90%',
            height: '20px',
            display: 'flex',
            justifyContent: 'space-between',
            position: 'relative',
          }}
        >
          {Array.from({ length: 25 }).map((_, index) => (
            <div
              key={index}
              style={{
                position: 'absolute',
                left: `${(index / 24) * 100}%`,
                transform: 'translateX(-50%)',
                fontSize: '10px',
                fontWeight: 'bold',
              }}
            >
              {`${index.toString().padStart(2, '0')}:00`}
            </div>
          ))}
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {/* Vạch kẻ thời gian */}
        <div
          style={{
            width: '90%',
            height: '20px',
            position: 'relative',
          }}
        >
          {Array.from({ length: 24 * 6 }).map((_, index) => (
            <div
              key={index}
              style={{
                position: 'absolute',
                bottom: '0',
                left: `${(index / (24 * 6 - 1)) * 100}%`,
                transform: 'translateX(-50%)',
                height: index % 6 === 0 ? '9px' : '2px',
                width: '1px',
                backgroundColor: '#ffffffa6',
              }}
            />
          ))}
        </div>
      </div>
      {/* Thanh tiến trình */}
      <div
        style={{
          marginTop: '10px',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {tooltipVisible && (
          <div
            style={{
              position: 'fixed',
              top: `${tooltipPosition.top}px`,
              left: `${tooltipPosition.left}px`,
              background: 'rgba(255, 255, 255, 0.5)',
              color: '#fff',
              padding: '4px 8px',
              borderRadius: '4px',
              pointerEvents: 'none',
              transform: 'translateX(-50%)',
            }}
          >
            {playTime}
          </div>
        )}

        <div
          style={{
            height: '8px',
            background: '#1757B7',
            cursor: 'pointer',
            width: '90%',
            position: 'relative',
          }}
          onClick={handleSeek}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          {/* Vạch vàng */}
          <div
            style={{
              position: 'absolute',
              left: `${played * 100}%`,
              transform: 'translateX(-50%)',
              height: '100%',
              background: '#FFD900',
              transition: 'left 0.1s ease',
              width: '7px',
            }}
          />

          <img
            style={{
              left: '-5%',
            }}
            className="arrow-process"
            alt="ArrowLeftCircle"
            src={ArrowLeftCircle}
            onClick={handleSeekBack}
          />
          <img
            style={{
              right: '-5%',
            }}
            className="arrow-process"
            alt="ArrowRightCircle"
            src={ArrowRightCircle}
            onClick={handleSeekForward}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
